import { GridsterConfig } from 'angular-gridster2';
import { InjectionToken } from '@angular/core';

export const LICENSE_LAYOUT_CONFIG = new InjectionToken<GridsterConfig>('ui.license');

export const licenseLayoutConfiguration: GridsterConfig = {
  draggable: {
    enabled: false,
  },
  resizable: {
    enabled: false,
  },
  displayGrid: 'none',
  maxRows: 5,
  minRows: 5,
  maxCols: 4,
  minCols: 4,
};
